import { PureComponent } from 'react'
import * as styles from 'components/features/pfm/RedemptionForm/SuccessStep.css'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { REWARDS_PAGE } from 'constants/pages'
import Button from 'components/features/pfm/Button/Button'
import redemptionReduxForm from 'components/features/pfm/RedemptionForm/redemptionReduxForm'
import { ReduxFormProps } from 'interfaces/component'
import { RedemptionFormValues } from 'interfaces/bounty'

type SuccessStepProps = ReduxFormProps<RedemptionFormValues> & {}

class SuccessStep extends PureComponent<SuccessStepProps> {
  render () {
    return (
      <section className={ styles.successStep }>
        <div className={ styles.buttonWrapper }>
          <NavigationLink to={ REWARDS_PAGE }>
            <Button fullWidth qaMarker='form-back-button'>
              Back to Your Rewards
            </Button>
          </NavigationLink>
        </div>
        <div className={ styles.noteTitle }>Please Note</div>
        <div className={ styles.noteText }>
          Transfers can take up to 5-10 business
          <br />
          days to complete.
        </div>
      </section>
    )
  }
}

export default redemptionReduxForm(SuccessStep)
